//#region Libraries
//#endregion
//#region Styles
import { Column, Row } from "components/styles";
import { Container, Student, 
    Description, Adviser, 
    Title } from "./styles";
import { DateTimeGroup, TextData } from "views/components/Schedules/components/UpdateActivityPopup/styles";
//#endregion
//#region Components
import DialogAlert from "components/DialogAlert/DialogAlert";
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import TimerIcon from "icons/TimerIcon";
import CalendarIcon from "icons/CalendarIcon";
//#endregion

const DialogUpcomingScheduleSuccessfulReassignment = ({
    show, toggleShow,
    currentSchedule, student,
    reloadData
}) => {
    const backToSchedules = () => {
        toggleShow(false);
        setTimeout(() => {
            reloadData({
                message: `Se realizó exitosamente la reasignación del estudiante con un nuevo asesor.`,
                variant: "success",
                milis: 3000
            });
        }, 400);
    }
    return (
        <DialogAlert 
            show={show} 
            toggleShow={toggleShow}
            close={backToSchedules}>
            <Container>
                <Column align="center" gap="15px">
                    <Title>¡Asignación exitosa!</Title>
                    <Student>{student}</Student>
                    <Description>Será atendido (a) en el siguiente horario</Description>
                    <Adviser>{currentSchedule?.adviser?.name || "-"}</Adviser>
                    <Row>
                        <DateTimeGroup>
                            <TimerIcon size={16}/>
                            <TextData>{currentSchedule.timeStr}</TextData>
                        </DateTimeGroup>
                        <DateTimeGroup>
                            <CalendarIcon size={16}/>
                            <TextData>{currentSchedule.dateStr}</TextData>
                        </DateTimeGroup>
                    </Row>
                </Column>
                <CustomButton 
                    text="Volver al horario"
                    onClick={backToSchedules}/>
            </Container>
        </DialogAlert>
    );
}

export default DialogUpcomingScheduleSuccessfulReassignment;